import Header from './Header'
import Footer from './Footer'

function RegistroMarcas() {
    const title =  'Registro de marcas'
    return (
        <>
            <Header/>
            <main id="main">
                {/* ======= Breadcrumbs ======= */}
                <section id="breadcrumbs" className="breadcrumbs">
                  <div className="container">
                    <ol>
                      <li><a href="/">Inicio</a></li>
                      <li>{title}</li>
                    </ol>
                    {/*h2>{title}</h2*/}
                    <div className="row">
                      <div className="col-lg-6 order-1 order-lg-2" data-aos="fade-left">
                        <img src="assets/img/registro-marcas.png" className="img-fluid" alt="registro de marcas" style={{'padding': '5%'}} />
                      </div>
                      <div className="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content" data-aos="fade-right">
                        <h3>{title}</h3>
                        <p className="justified-text">Ofrecemos un servicio integral de registro de marcas ante el INPI (Instituto Nacional de la Propiedad Industrial), acompañándote en todo el proceso para proteger tu marca de manera eficiente y segura.</p>
                        <p className="justified-text">Nuestro equipo se encarga de la búsqueda de antecedentes, la presentación de la solicitud y el seguimiento del trámite hasta la obtención del registro.</p>
                        <p className="justified-text">También ofrecemos un servicio de <strong>vigilancia de marca</strong>: monitoreamos de forma permanente las nuevas solicitudes de registro publicadas en el boletín del INPI para detectar marcas similares o idénticas a la tuya. Si identificamos un intento de registro que pueda afectar tus derechos, realizamos la <strong>presentación de oposiciones</strong> en tiempo y forma, protegiendo tu marca frente a terceros que intenten apropiarse de tu identidad comercial.</p>
                        <p className='justified-text'><strong>No dejes desprotegida tu marca.</strong> Escribinos y te asesoramos sobre cómo registrarla y mantenerla protegida.</p>
                        <br/>
                        <a href="https://wa.me/+5491124089830?text=Hola%2C%20quiero%20registrar%20mi%20marca" className="cta-button">Quiero proteger mi marca</a>
                      </div>
                    </div>
                  </div>
                </section>{/* End Breadcrumbs */}
            </main>
            <Footer/>
        </>
    );
}

export default RegistroMarcas;
